module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_twitter-11735c726ae38e86fad547718f18a677.svg";